import type { ReactNode } from 'react';
import { Collapse } from 'react-bootstrap';

export function CollapseBody(props: { children: ReactNode; isOpen: boolean }) {
    return (
        <Collapse in={props.isOpen}>
            <div>{props.children}</div>
        </Collapse>
    );
}
